import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import {
    Autocomplete, Box, Button, Card, CardContent, CircularProgress,
    Drawer, Stack, TextField, Tooltip, Typography, Modal, IconButton,
    RadioGroup, Radio, FormControlLabel, 
} from '@mui/material';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { Colors } from '../../../Styles/Colors';
import Loader from '../../../Components/Loader';

class BedAvailable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            BedList: [],
            isLoding: false,
            wardType: null,
            BlockList: [],
            blockType: null,
            FloorList: [],
            floorType: null,
            roomList: [],
            roomType: null,
            bedData: [],
            bedType: null,
            BedList_filter: [],
            BlockList_view: [],
            FloorList_View: [],
            roomList_View: [],
            bedData_View: [],
            dupBedListData: '[]',
            isOpen: false,
            slcCardDlt: {},
            bedChangedStatus: "",
            isSave: false,
        }
    }

    componentDidMount() {
        this.GetBedList()
    }

    GetBedList = () => {
        try {
            this.setState({
                isLoding: true
            })
            RestAPIService.getAll(Serviceurls.IP_BED_AVAILABLE)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            BedList: this.RemoveDuplicates(response.data.data, 'ward_id'),
                            BedList_dup: response.data.data,
                            dupBedListData: JSON.stringify(response.data.data),
                            isLoding: false
                        })
                    }
                    else {
                        this.setState({
                            isLoding: false
                        })
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.setState({
                        isLoding: false
                    })
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        }
        catch (error) {
            this.setState({
                isLoding: false
            })
            if (error?.response?.data?.status === "fail") {
                this.errorMessage(error.response.data.message)
            } else {
                this.errorMessage(error.message)
            }
        }
    }

    closeFilter() {
        this.setState({
            FilterOpen: false
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    RemoveDuplicates(Array, key) {
        const FilteredArray = Array.reduce((accumulator, current) => {
            if (!accumulator.find((item) => item[key] === current[key])) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);

        return FilteredArray
    }

    renderFilterScreen = () => {
        const { t } = this.props
        let wardData = []
        wardData = this.state.BedList_dup
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button emed_tid="bed_available_filter_close_btn" onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={wardData}
                            clearIcon
                            emed_tid="bed_available_block_select"
                            getOptionLabel={(option) => (option?.block)}
                            value={this.state?.wardType}
                            onChange={(event, newValue) => {
                                this.setState({
                                    wardType: newValue,
                                    blockType: null,
                                    floorType: null,
                                    roomType: null,
                                    FloorList: [],
                                    roomList: [],
                                }, () => {
                                    var states = this.state
                                    if (this.state.wardType) {
                                        // let block = this.RemoveDuplicates(states.filterDataDup.filter((item) => item.ward_id === states?.wardType?.ward_id), 'block_no_id')
                                        // let block_view = states.filterDataDup.filter((item) => item.ward_id === states?.wardType?.ward_id)
                                        this.setState({
                                            BlockList: states.wardType?.block_data,
                                            BlockList_view: states.wardType?.block
                                        })
                                    } else {
                                        this.setState({
                                            BlockList: [],
                                            BlockList_view: null,
                                            BedList_dup:JSON.parse(this.state.dupBedListData)
                                        })
                                    }
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Block')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            clearIcon
                            disabled={this.state.BlockList?.length === 0}
                            options={this.state?.BlockList}
                            emed_tid="bed_available_ward_select"
                            getOptionLabel={(option) => (option?.ward_name)}
                            value={this.state.BlockList?.length > 0 ? this.state?.blockType : null}
                            onChange={(event, newValue) => {
                                this.setState({
                                    blockType: newValue,
                                    floorType: null,
                                    roomType: null,
                                    roomList: [],
                                }, () => {
                                    var states = this.state
                                    if (this.state.blockType) {
                                        // let floor = this.RemoveDuplicates(states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType?.block_no_id)), 'floor')
                                        // let floor_view = states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType?.block_no_id))
                                        this.setState({
                                            FloorList: states.blockType?.ward_data,
                                            FloorList_View: states.blockType?.ward_name
                                        })
                                    } else {
                                        this.setState({
                                            FloorList: [],
                                            FloorList_View: null,
                                            BedList_dup:JSON.parse(this.state.dupBedListData)
                                        })
                                    }
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Ward')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            clearIcon
                            size='small'
                            disabled={this.state.FloorList?.length === 0}
                            options={this.state?.FloorList}
                            emed_tid="bed_available_floor_select"
                            getOptionLabel={(option) => (option?.floor)}
                            value={this.state.FloorList?.length > 0 ? this.state?.floorType : null}
                            onChange={(event, newValue) => {
                                this.setState({
                                    floorType: newValue,
                                    roomType: null,
                                }, () => {
                                    var states = this.state
                                    if (this.state.floorType) {
                                        // let room = this.RemoveDuplicates(states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType.block_no_id && item.floor === states?.floorType?.floor)), 'room_number')
                                        // let room_View = states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType.block_no_id && item.floor === states?.floorType?.floor))
                                        this.setState({
                                            roomList: states.floorType?.floor_data,
                                            roomList_View: states.floorType?.floor
                                        })
                                    } else {
                                        this.setState({
                                            roomList: [],
                                            roomList_View: null,
                                            BedList_dup:JSON.parse(this.state.dupBedListData)
                                        })
                                    }
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Floor')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            clearIcon
                            size='small'
                            disabled={this.state.roomList?.length === 0}
                            options={this.state.roomList?.length > 0 ? this.state?.roomList : null}
                            emed_tid="bed_available_bed_select"
                            getOptionLabel={(option) => (option?.bed_number)}
                            value={this.state?.roomType}
                            onChange={(event, newValue) => {
                                this.setState({
                                    roomType: newValue
                                }, () => {
                                    var states = this.state
                                    if (this.state.roomType) {
                                        // let bedItem = this.RemoveDuplicates(states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType.block_no_id && item.floor === states?.floorType?.floor && item.room_number === states.roomType?.room_number)), 'bed_id')
                                        // let bedItem_view = states.filterDataDup?.filter((item) => (item.ward_id === states.wardType.ward_id && item.block_no_id === states.blockType.block_no_id && item.floor === states?.floorType?.floor && item.room_number === states.roomType?.room_number))
                                        this.setState({
                                            bedData: states.roomType,
                                            bedData_View: states.roomType?.bed_number
                                        })
                                    } else {
                                        this.setState({
                                            bedData: [],
                                            bedData_View: null,
                                            BedList_dup:JSON.parse(this.state.dupBedListData)
                                        })
                                    }
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Bed')}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" emed_tid="bed_available_filter_clear_btn"
                        onClick={() => {
                            this.setState({
                                BlockList: [],
                                FloorList: [],
                                roomList: [],
                                wardType: null,
                                blockType: null,
                                floorType: null,
                                roomType: null,
                                FilterOpen: false,
                                BedList_filter: [],
                                bedData: [],
                                BlockList_view: [],
                                FloorList_View: [],
                                roomList_View: [],
                                bedData_View: [],
                            }, () => {
                                this.GetBedList()
                                this.setState({
                                    BedList: this.state.BedList_dup
                                })
                            })
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid="bed_available_filter_search_btn"
                        // onClick={() => {
                        //     if (this.state.wardType !== null &&
                        //         this.state.blockType === null &&
                        //         this.state.floorType === null &&
                        //         this.state.roomType === null) {
                        //         this.setState({
                        //             BedList_filter: this.state.BlockList_view
                        //         })
                        //     } else if (this.state.blockType !== null &&
                        //         this.state.floorType === null &&
                        //         this.state.roomType === null) {
                        //         this.setState({
                        //             BedList_filter: this.state.FloorList_View
                        //         })
                        //     } else if (this.state.floorType !== null &&
                        //         this.state.roomType === null) {
                        //         this.setState({
                        //             BedList_filter: this.state.roomList_View
                        //         })
                        //     } else if (this.state.roomType !== null) {
                        //         this.setState({
                        //             BedList_filter: this.state.bedData_View
                        //         })
                        //     } else {
                        //         this.setState({
                        //             BedList_filter: this.state.BedList_dup
                        //         })
                        //     }
                        //     this.setState({
                        //         FilterOpen: false
                        //     })
                        // }}
                        onClick={() => {
                            let dupBedListData = JSON.parse(this.state.dupBedListData)
                            if (this.state.wardType !== null &&
                                this.state.blockType === null &&
                                this.state.floorType === null &&
                                this.state.roomType === null) {
                                let data = dupBedListData?.find(element => (element?.block === this.state.BlockList_view))

                                this.setState({ BedList_dup: [data] })
                            } else if (this.state.blockType !== null &&
                                this.state.floorType === null &&
                                this.state.roomType === null) {
                                let data = dupBedListData?.find(element => (element?.block === this.state.BlockList_view))
                                let blockData = data?.block_data?.find(item => item?.ward_name === this.state.FloorList_View)
                                data.block_data = [blockData]

                                this.setState({ BedList_dup: [data] })
                            } else if (this.state.floorType !== null &&
                                this.state.roomType === null) {
                                let data = dupBedListData?.find(element => (element?.block === this.state.BlockList_view))
                                let blockData = data?.block_data?.find(item => item?.ward_name === this.state.FloorList_View)
                                let wardData = blockData?.ward_data?.find(item => item?.floor === this.state.roomList_View)

                                blockData.ward_data = [wardData]
                                data.block_data = [blockData]

                                this.setState({ BedList_dup: [data] })
                            } else if (this.state.roomType !== null) {
                                let data = dupBedListData?.find(element => (element?.block === this.state.BlockList_view))
                                let blockData = data?.block_data?.find(item => item?.ward_name === this.state.FloorList_View)
                                let wardData = blockData?.ward_data?.find(item => item?.floor === this.state.roomList_View)
                                let roomData = wardData?.floor_data?.find(item => item?.bed_number === this.state.bedData_View)

                                wardData.floor_data = [roomData]
                                blockData.ward_data = [wardData]
                                data.block_data = [blockData]

                                this.setState({ BedList_dup: [data] })
                            } else {
                                this.setState({ BedList_dup: dupBedListData })
                            }
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }
    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    handleCardClk = (data) => {
        if (data?.is_available || data?.is_under_maintenance || data?.is_room_cleaning) {
            this.setState({
                isOpen: true,
                slcCardDlt: data,
                bedChangedStatus: data?.is_under_maintenance ? "maintenance" :
                    data?.is_room_cleaning ? "cleaning" : "available"
            })
        }
    }

    handleClose = () => {
        this.setState({
            isOpen: false,
            slcCardDlt: {},
            bedChangedStatus: ""
        })
    }

    handleSave = () => {
        try {
            let { slcCardDlt, bedChangedStatus } = this.state;
            let data = {
                "bed_id": slcCardDlt?.bed_id,
                "maintenance": bedChangedStatus === "maintenance",
                "cleaning": bedChangedStatus === "cleaning",
                "available": bedChangedStatus === "available",
            }
            RestAPIService.create(data, Serviceurls.IP_BED_AVAILABLE_STATUS_POST)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.handleClose();
                        this.setState({ isSave: false })
                        this.GetBedList();
                        this.successMessage(response.data.message)
                    } else {
                        this.setState({ isSave: false })
                        this.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.setState({ isSave: false })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({ isSave: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ isSave: false })
            this.errorMsgFunc(error.message)
        }
    }

    cleaningPopup = () => {
        const { slcCardDlt, isSave } = this.state;
        return (<Modal open={true}>
            <Box className="eMed_bedavl_pop_container">
                <Box component={'div'} display={"flex"} alignItems={"center"} justifyContent={"space-between"} borderBottom={"1px solid #616161"} padding={"0.5dvw"}>
                    <Typography fontWeight={600} fontSize={"1dvw"}>Change Status</Typography>
                    <IconButton size="small" emed_tid="bed_status_popup_close_btn" onClick={this.handleClose}>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </IconButton>
                </Box>
                <Typography marginX={"0.625dvw"} marginTop={"1dvw"} fontSize={"0.9dvw"} color={"#616161"}>Bed Details</Typography>
                <Box className="eMed_bedavl_grid_container">
                    <Typography fontSize={"1dvw"}>
                        Bed No: <span style={{ color: "black", fontSize: "1dvw", fontWeight:600 }}>
                            {slcCardDlt?.bed_number || "-"}
                        </span>
                    </Typography>
                    <Typography fontSize={"1dvw"}>
                        Room No: <span style={{ color: "black", fontSize: "1dvw", fontWeight:600 }}>
                            {slcCardDlt?.room_number || "-"}
                        </span>
                    </Typography>
                    <Typography fontSize={"1dvw"}>
                        Block: <span style={{ color: "black", fontSize: "1dvw", fontWeight:600 }}>
                            {slcCardDlt?.block || "-"}
                        </span>
                    </Typography>
                    <Typography fontSize={"1dvw"}>
                        Floor No: <span style={{ color: "black", fontSize: "1dvw", fontWeight:600 }}>
                            {slcCardDlt?.floor || "-"}
                        </span>
                    </Typography>
                    <Typography fontSize={"1dvw"}>
                        Ward: <span style={{ color: "black", fontSize: "1dvw" , fontWeight:600}}>
                            {slcCardDlt?.ward__ward_name || "-"}
                        </span>
                    </Typography>
                </Box>
                <Typography marginX={"0.625dvw"} fontSize={"0.95dvw"} color={"#616161"}>Status</Typography>
                <RadioGroup
                    value={this.state.bedChangedStatus}
                    emed_tid="bed_status_radio_group"
                    sx={{ display: 'flex', flexDirection: 'row', marginBottom: '1dvw', marginX: "0.625dvw" }}
                    onChange={(e) => {
                        this.setState({ bedChangedStatus: e.target.value })
                    }}
                >
                    <FormControlLabel value={'cleaning'} emed_tid="bed_status_cleaning_radio" control={<Radio size='small' />} label="Under Cleaning" />
                    <FormControlLabel value={"maintenance"} emed_tid="bed_status_maintenance_radio" control={<Radio size='small' />} label="Under Maintenance" />
                    <FormControlLabel value={"available"} emed_tid="bed_status_available_radio" control={<Radio size='small' />} label="Available" />
                </RadioGroup>
                <Button
                    disabled={isSave}
                    emed_tid="bed_status_save_btn"
                    sx={{ textTransform: 'capitalize', float: "right", marginRight: "0.625dvw", marginBottom: "1dvw" }}
                    variant='contained' size='small'
                    onClick={() => {
                        this.setState({ isSave: true },
                            () => { this.handleSave() })
                    }}
                >
                    Save</Button>
            </Box>
        </Modal>)
    }

    renderRoomData = () => {
        var states = this.state
        // let ViewData = states?.filterDataDup?.length > 0 ? states.filterDataDup : states?.BedList_dup?.length > 0 ? states?.BedList_dup : []
        return (
            <Box id=''>
                {states.isLoding ?
                    <Box id='eMed_Bed_Circle'>
                        <CircularProgress color='primary' />
                    </Box> :
                    // : ViewData?.length > 0 ? ViewData?.map((list, index) => {
                    //     return (
                    //         <Card id='eMed_Bed_CardView' sx={{ border: '0.2vw solid', borderColor: list.is_available ? '#00b300' : 'white', backgroundColor: list.is_available ? '#e6ffe6' : 'white' }}>
                    //             <CardContent sx={{ width: '8vw' }}>
                    //                 <Box style={{ display: 'flex', flexDirection: 'row', width: '7vw' }}>
                    //                     {list.room_number.length > 3 ?
                    //                         <Tooltip title={list.room_number} placement='top'>
                    //                             <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                    //                                 {list.room_number ? '..' + list.room_number.slice(-3) + ' / ' : '-'}
                    //                             </Typography>
                    //                         </Tooltip> : <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                    //                             {`${list.room_number ? list.room_number + ' / ' : '-'}`}
                    //                         </Typography>}
                    //                     <Box sx={{ marginLeft: '0.2vw' }}>
                    //                         {list.bed_number.length > 3 ?
                    //                             <Tooltip title={list.bed_number} placement='top'>
                    //                                 <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                    //                                     {list.bed_number ? '..' + list.bed_number.slice(-3) : '-'}
                    //                                 </Typography>
                    //                             </Tooltip> : <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                    //                                 {`${list.bed_number ? list.bed_number : '-'}`}
                    //                             </Typography>}
                    //                     </Box>
                    //                 </Box>
                    //                 <Box sx={{ display: 'flex', flexDirection: 'row', width: '7.3vw' }}>
                    //                     <Typography sx={{ fontSize: '0.8vw' }}>
                    //                         {"Room / Bed No"}
                    //                     </Typography>
                    //                     {list.ward_type === "NON AC" ? null : <img style={{ width: '0.7vw', height: '0.7vw' }} src={ImagePaths.AC_Icon.default} alt='AC' />}
                    //                 </Box>
                    //                 <Box id='eMed_Bed_wardText'>
                    //                     <img src={ImagePaths.WardIcon.default} style={{ width: '1vw', height: '1vw' }} alt={'ward'} />
                    //                     {list?.ward__ward_name?.length > 8 ?
                    //                         <Tooltip title={list?.ward__ward_name} placement='top'>
                    //                             <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                    //                                 {list.ward__ward_name ? list.ward__ward_name.slice(0, 8) + '...' : '-'}
                    //                             </Typography>
                    //                         </Tooltip> :
                    //                         <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                    //                             {list.ward__ward_name ? list.ward__ward_name : '-'}
                    //                         </Typography>}

                    //                 </Box>
                    //                 <Box id='eMed_Bed_FloorText' sx={{}}>
                    //                     <img src={ImagePaths.FloorIcon.default} style={{ width: '1vw', height: '1vw' }} alt={'ward'} />
                    //                     {list?.block?.length > 8 ?
                    //                         <Tooltip title={list?.block + " Floor"} placement='top'>
                    //                             <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                    //                                 {list.block ? list.block.slice(0, 8) + '...' : '-'}
                    //                             </Typography>
                    //                         </Tooltip> :
                    //                         <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                    //                             {list?.block ? list?.block : '-'}
                    //                         </Typography>}
                    //                 </Box>
                    //             </CardContent>
                    //             <Box id='eMed_Bed_FloorCon' sx={{ backgroundColor: Colors.themeBackgroud }}>
                    //                 <Typography sx={{ fontSize: '0.8vw', color: 'white', fontWeight: 'bold' }}>
                    //                     {`${list?.floor ? list?.floor : '-'}F`}
                    //                 </Typography>
                    //             </Box>
                    //         </Card>
                    //     )
                    // }) : null
                    <Box component={'div'} height={'70vh'} overflow={'auto'}>
                        {states.BedList_dup?.length > 0 ? states.BedList_dup?.map((blockItem, blockIndex) => (
                            <Box component={'div'} key={blockIndex}>
                                {blockItem?.block_data?.length > 0 ? blockItem?.block_data?.map((wardItem, wardIndex) => (
                                    <Box component={'div'} key={wardIndex} ml={'1.5vw'}>
                                        {wardItem?.ward_data?.length > 0 ? wardItem?.ward_data?.map((floorData, floorIndex) => (
                                            <><Box component={'div'} key={floorIndex} display={'flex'} flexDirection={'column'}>
                                                <Box component={'div'} display={'flex'}>
                                                    <Box component={'div'} display={'flex'} ml={'0.5vw'}>
                                                        <Typography color={Colors.grayShade}>{'Block Name : '}</Typography>
                                                        <Typography fontWeight={600}>{`${blockItem?.block ? blockItem?.block : '-'} /`}</Typography>
                                                    </Box>
                                                    <Box component={'div'} display={'flex'} ml={'0.5vw'}>
                                                        <Typography color={Colors.grayShade}>Ward Name :</Typography>
                                                        <Typography fontWeight={600}>{` ${wardItem?.ward_name ? wardItem?.ward_name : '-'} /`}</Typography>
                                                    </Box>
                                                    <Box component={'div'} display={'flex'} ml={'0.5vw'}>
                                                        <Typography color={Colors.grayShade}>{"Floor :"}</Typography>
                                                        <Typography fontWeight={600}>{`${floorData?.floor ? floorData?.floor : '-'}`}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box component={'div'} display={'flex'} flexWrap={'wrap'}>
                                                    {floorData?.floor_data?.length > 0 ? floorData?.floor_data?.map((list, index) => {
                                                        const cardBorder = list?.is_available ? '#00b300' : list?.is_under_maintenance ? '#00B7FF': list?.is_room_cleaning ? '#FFBF00': 'white';
                                                        const cardBgColor = list?.is_available ? '#e6ffe6' : list?.is_under_maintenance ? '#BAECFF': list?.is_room_cleaning ? '#FFF6DC': 'white';
                                                        const cardCursor = (list?.is_available || list?.is_under_maintenance || list?.is_room_cleaning) ? "pointer" : "default";
                                                        return (
                                                            <Box component={'div'} display={'flex'} key={index}>
                                                                <Card id='eMed_Bed_CardView' 
                                                                sx={{ border: '0.2vw solid', borderColor: cardBorder, backgroundColor: cardBgColor, cursor: cardCursor}}
                                                                onClick = {() => {this.handleCardClk(list)}}>
                                                                    <CardContent sx={{ width: '8vw' }}>
                                                                        <Box style={{ display: 'flex', flexDirection: 'row', width: '7vw' }}>
                                                                            {list.room_number?.length > 3 ?
                                                                                <Tooltip title={list.room_number} placement='top'>
                                                                                    <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                                                                                        {list.room_number ? '..' + list.room_number.slice(-3) + ' / ' : '-'}
                                                                                    </Typography>
                                                                                </Tooltip> : <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                                                                                    {`${list.room_number ? list.room_number + ' / ' : '-'}`}
                                                                                </Typography>}
                                                                            <Box sx={{ marginLeft: '0.2vw' }}>
                                                                                {list.bed_number.length > 3 ?
                                                                                    <Tooltip title={list.bed_number} placement='top'>
                                                                                        <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                                                                                            {list.bed_number ? '..' + list.bed_number.slice(-3) : '-'}
                                                                                        </Typography>
                                                                                    </Tooltip> : <Typography sx={{ fontSize: '1vw', fontWeight: 'bold' }}>
                                                                                        {`${list.bed_number ? list.bed_number : '-'}`}
                                                                                    </Typography>}
                                                                            </Box>
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'row', width: '7.3vw' }}>
                                                                            <Typography sx={{ fontSize: '0.8vw' }}>
                                                                                {"Room / Bed No"}
                                                                            </Typography>
                                                                            {list.ward_type === "NON AC" ? null : <img style={{ width: '0.7vw', height: '0.7vw' }} src={ImagePaths.AC_Icon.default} alt='AC' />}
                                                                        </Box>
                                                                        <Box id='eMed_Bed_wardText'>
                                                                            <img src={ImagePaths.WardIcon.default} style={{ width: '1vw', height: '1vw' }} alt={'ward'} />
                                                                            {list?.ward__ward_name?.length > 8 ?
                                                                                <Tooltip title={list?.ward__ward_name} placement='top'>
                                                                                    <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                                                                                        {list.ward__ward_name ? list.ward__ward_name.slice(0, 8) + '...' : '-'}
                                                                                    </Typography>
                                                                                </Tooltip> :
                                                                                <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                                                                                    {list.ward__ward_name ? list.ward__ward_name : '-'}
                                                                                </Typography>}

                                                                        </Box>
                                                                        <Box id='eMed_Bed_FloorText' sx={{}}>
                                                                            <img src={ImagePaths.FloorIcon.default} style={{ width: '1vw', height: '1vw' }} alt={'ward'} />
                                                                            {list?.block?.length > 8 ?
                                                                                <Tooltip title={list?.block + " Floor"} placement='top'>
                                                                                    <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                                                                                        {list.block ? list.block.slice(0, 8) + '...' : '-'}
                                                                                    </Typography>
                                                                                </Tooltip> :
                                                                                <Typography sx={{ fontSize: '0.8vw', marginLeft: '1vw' }}>
                                                                                    {list?.block ? list?.block : '-'}
                                                                                </Typography>}
                                                                        </Box>
                                                                    </CardContent>
                                                                    <Box id='eMed_Bed_FloorCon' sx={{ backgroundColor: Colors.themeBackgroud }}>
                                                                        <Typography sx={{ fontSize: '0.8vw', color: 'white', fontWeight: 'bold' }}>
                                                                            {`${list?.floor ? list?.floor : '-'}F`}
                                                                        </Typography>
                                                                    </Box>
                                                                </Card>
                                                            </Box>
                                                        )
                                                    }) : null}
                                                </Box>
                                            </Box>
                                            </>
                                        )) : null}
                                    </Box>
                                )) : null}
                            </Box>
                        )) : null}
                    </Box>
                }
            </Box>
        )
    }

    render() {
        return (
            <Box component={"div"} className='eMed_Main_container' sx={{ height: '77vh' }}>
                <Box component={"div"} className='eMed_Top_Container' style={{ height: "8vh" }}>
                    <Box component={"div"} className='eMed_Action_Container' sx={{ flex: 2.15, display: 'flex', alignItems: 'center', columnGap: "0.625dvw"}}>
                        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                            <img src={ImagePaths.AvailabelRoom.default} alt="available" />
                            <Typography sx={{ fontSize: '1vw', marginLeft: '1vw' }}>{"Available Rooms"}</Typography>
                        </Box>
                        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                            <img src={ImagePaths.cleaningRoom.default} alt="available" />
                            <Typography sx={{ fontSize: '1vw', marginLeft: '1vw' }}>{"Under Cleaning"}</Typography>
                        </Box>
                        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                            <img src={ImagePaths.MaintenanceRoom.default} alt="available" />
                            <Typography sx={{ fontSize: '1vw', marginLeft: '1vw' }}>{"Under Maintenance"}</Typography>
                        </Box>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Tooltip title="Filter" placement='top' arrow>
                                <Button className='eMed_usrconf_btn' emed_tid="bed_available_filter_btn" onClick={() => { this.setState({ FilterOpen: true }) }}>
                                    <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                                </Button>
                            </Tooltip>
                        </Box>
                        {/* <Tooltip title="Print" placement='top' arrow>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.GetBedListexcel() }}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button></Tooltip> */}
                    </Box>
                </Box>
                <Box component={"div"} className='eMed_Table_Container'>
                    {this.renderRoomData()}
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter.bind(this) }}
                >{this.renderFilterScreen()}</Drawer>
                {
                    this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null
                }
                {
                    this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null
                }
                {this.state.isOpen && Object.keys(this.state.slcCardDlt)?.length > 0 && this.cleaningPopup()}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
export default withTranslation()(BedAvailable);